import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { actor, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="container muted">Loading…</div>;
  if (actor?.kind !== 'user') {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
